import React, {Component, useEffect, useState} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import VehicleYearChooserUI from "./VehicleYearChooserUI";
import {saveSessionVehicle} from "../ReduxStore/CustomerVehicle/vehicleSlice";
import LocalUrlMaker from "../lib/LocalUrlMaker";
import YearPrompt from "./YearPrompt";
import {camelizeKeys, camelizeKeysDeep} from "../ReduxStore/Helpers/transformObject";
import {getDispatch} from "../Utility/ReduxHelper";

/**
 * A very simplified VehicleSelector, this just uses local state
 * for options and choices, not Redux.
 *
 * Found on shop by vehicle pages and vehicle-category landing pages.
 *
 */
export default function VehicleYearChooserContainer(props) {
  props = camelizeKeysDeep(props);  // FIXME camelize

  return <VehicleYearChooserContainerInner {...props} />
}

function VehicleYearChooserContainerInner({years, customerVehicle, vehicleModel, uplink, vehicleContext}) {
  const [year, setYear] = useState(null);

  useEffect(() => {
    if (!year || !customerVehicle?.id)
      return;

    let url = new URL(globalThis.location);
    url.search = "year=" + year;
    globalThis.location = url.toString();
  }, [customerVehicle, year]);

  // Has the user already selected the vehicle we're asking about?
  // in that case we know the year and we're done...
  const isComplete = customerVehicle && vehicleModel &&
    (+customerVehicle.vehicleModelId === +vehicleModel.id);

  if (isComplete) {
    return <div/>
  }

  const handleSelect = (year) => {
    const dispatch = getDispatch();

    if (!year || !vehicleModel)
      return;

    let params = {year: year, model: vehicleModel.id, from: "VehicleYearChooser"};

    dispatch(saveSessionVehicle({
      params: params,
      vehicleContext: {source: 'user'}
      // FIXME: config.productContext
    }));

    setYear(year);
  }

  return (
    <div id="vehicle-selector"
      className="vehicle-selector vehicle-selector-incomplete vehicle-selector-horizontal vehicle-year-chooser">

      <YearPrompt vehicleModel={vehicleModel} uplink={uplink}/>

      <VehicleYearChooserUI
        uplink={uplink}
        vehicleModel={vehicleModel}
        years={years}
        onSelectYear={handleSelect}/>
    </div>
  );
}


